import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import './CompanyNamePIC.scss';
import CompanyNamePICInput from './CompanyNamePICInput';
import CompanyNamePICSearch from './CompanyNamePICSearch';
import CompanyNamePICTable from './CompanyNamePICTable';
import { setTriggerRefreshInput, setTriggerSave } from './reducers/CompanyNamePICInputReducer';
import { resetCompanyNamePICSearch, setTriggerCompanyNamePICSearch } from './reducers/CompanyNamePICSearchReducer';

let triggerHotkeyAlready = false;

const CompanyNamePIC: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);

    useEffect(() => {
        document.title = "CompanyName - PIC";

        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    }, []);

    const handleKeyPress = useCallback((event) => {
        if (!triggerHotkeyAlready) {
            if (event.altKey) {
                switch (event.key) {
                    case "s":
                        //save
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerSave((new Date()).getTime()));
                        break;
                    case "r":
                        //refresh save
                        dispatch(setTriggerRefreshInput((new Date()).getTime()));
                        break;
                    case "w":
                        //search
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerCompanyNamePICSearch((new Date()).getTime()));
                        break;
                    case "q":
                        //refresh search
                        dispatch(resetCompanyNamePICSearch());
                        break;
                    default:
                        break;
                }
            }

            setTimeout(() => {
                triggerHotkeyAlready = false;
            }, 2000);
        }
    }, []);

    return (
        <>
            <Grid container className="tonnage">
                <Grid item lg={2} xs={12} className="left-search-area">
                    <CompanyNamePICSearch></CompanyNamePICSearch>
                </Grid>
                <Grid item lg={10} xs={12} className="right-content">
                    <Grid container className="input-fields">
                        <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                            <CompanyNamePICInput></CompanyNamePICInput>
                        </div>
                    </Grid>
                    <Grid container className="datatable">
                        <CompanyNamePICTable>
                        </CompanyNamePICTable>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
};

export default CompanyNamePIC;